(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('VerifytxCredentialDialogController', VerifytxCredentialDialogController);

    VerifytxCredentialDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'VerifytxCredential'];

    function VerifytxCredentialDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, VerifytxCredential) {
        var vm = this;

        vm.verifytxCredential = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.verifytxCredential.id !== null) {
                VerifytxCredential.update(vm.verifytxCredential, onSaveSuccess, onSaveError);
            } else {
                VerifytxCredential.save(vm.verifytxCredential, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:verifytxCredentialUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
